import React, { useEffect, useState } from "react";
import Routes from "./Routes";
import "./App.css";
import { Text } from "./components";
import { loadingChanges } from "./states/progress.mjs";
import { cacheDb } from "./service/cache";
import { initCart } from "./states/cart.mjs";

function App() {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const subscription = loadingChanges((value) => {
      setLoading(value);
    });
    return () => subscription.unsubscribe();
  }, []);

  React.useEffect(() => {
    cacheDb.carts.get("cart")
      .then(initCart)
      .catch(console.error);
  }, []);

  return <>
    <Routes />
    {
      loading && <div
        className="z-40 fixed top-0 left-0 right-0 bottom-0 flex-col opacity-80 bg-black-900 flex justify-center items-center">
        <div className="lds-hourglass" />
        <Text className="text-gray-300 mt-2">Please wait...</Text>
      </div>
    }
  </>;
}

export default App;
